import { useState, useEffect } from "react";
import { Table, Checkbox } from "antd";

const LOCAL_STORAGE_KEY = "shortcutManagerActiveState";

const dataSource = [
  { key: "1", active: true, button: "Alpha Formula Builder", keystrokes: "Ctrl + Alt + Shift + 1" },
  { key: "2", active: true, button: "Alpha Audit", keystrokes: "Ctrl + Alt + Shift + 2" },
  { key: "3", active: true, button: "Refresh Selection", keystrokes: "Ctrl + Alt + Shift + 3" },
  { key: "4", active: true, button: "Refresh Worksheet", keystrokes: "Ctrl + Alt + Shift + 4" },
  { key: "5", active: true, button: "Refresh Workbook", keystrokes: "Ctrl + Alt + Shift + 5" },
  { key: "6", active: true, button: "Upload Templates", keystrokes: "Ctrl + Alt + Shift + 6" },
  { key: "7", active: true, button: "Upload Builder", keystrokes: "Ctrl + Alt + Shift + 7" },
  { key: "8", active: true, button: "Product Education", keystrokes: "Ctrl + Alt + Shift + E" },
  { key: "9", active: true, button: "Settings", keystrokes: "Ctrl + Alt + Shift + S" },
  { key: "10", active: true, button: "Format Templates", keystrokes: "Ctrl + Alt + Shift + F" },
  { key: "11", active: true, button: "Feedback and Support", keystrokes: "Ctrl + Alt + Shift + 0" },
  { key: "12", active: true, button: "Sign In", keystrokes: "Ctrl + Alt + Shift + A" },
];
// Map action IDs used in your manifest/JSON to localStorage keys (string numbers)
const actionIdToKeyMap: Record<string, string> = {
  AlphaFormulaBuilderShortcut: "1",
  AlphaAuditShortcut: "2",
  RefreshSelectionShortcut: "3",
  RefreshWorksheetShortcut: "4",
  RefreshWorkbookShortcut: "5",
  UploadTemplatesShortcut: "6",
  UploadBuilderShortcut: "7",
  ProductEducationShortcut: "8",
  SettingsShortcut: "9",
  FormatTemplatesShortcut: "10",
  FeedbackAndSupportShortcut: "11",
  SignInShortcut: "12",
};

export function isActionActive(actionId: string): boolean {
  try {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!stored) return true; // default active if no data
    const states = JSON.parse(stored);

    const key = actionIdToKeyMap[actionId];
    if (!key) {
      console.warn(`No localStorage key mapped for actionId "${actionId}". Defaulting to active.`);
      return true;
    }

    // Return false if explicitly false, otherwise true
    return states[key] !== false;
  } catch (e) {
    console.error("Failed to read localStorage for action state:", e);
    return true; // fail safe
  }
}

const ShortcutManagerTable = () => {
  const [data, setData] = useState(dataSource);

  useEffect(() => {
    const savedState = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (savedState) {
      try {
        const parsedState = JSON.parse(savedState);
        setData((prevData) =>
          prevData.map((item) =>
            parsedState.hasOwnProperty(item.key) ? { ...item, active: parsedState[item.key] } : item
          )
        );
      } catch (error) {
        console.error("Failed to parse saved shortcut active state:", error);
      }
    }
  }, []);

  const onCheckboxChange = (checked, key) => {
    setData((prevData) => {
      const newData = prevData.map((item) => (item.key === key ? { ...item, active: checked } : item));

      const activeStateMap = {};
      newData.forEach(({ key, active }) => {
        activeStateMap[key] = active;
      });
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(activeStateMap));

      return newData;
    });
  };

  const columns = [
    {
      title: <b>Active</b>,
      dataIndex: "active",
      key: "active",
      width: 70,
      render: (_text, record) => (
        <Checkbox checked={record.active} onChange={(e) => onCheckboxChange(e.target.checked, record.key)} />
      ),
    },
    {
      title: <b>Button</b>,
      dataIndex: "button",
      key: "button",
      render: (text) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },
    {
      title: <b>Key Strokes</b>,
      dataIndex: "keystrokes",
      key: "keystrokes",
      render: (text) => <span style={{ fontWeight: "600" }}>{text}</span>,
    },
  ];

  return (
    <div style={{ width: "100%", fontFamily: "Arial, sans-serif" }}>
      <Table dataSource={data} columns={columns} pagination={false} bordered size="middle" rowKey="key" />
    </div>
  );
};

export default ShortcutManagerTable;
